import { connect } from 'react-redux';
import {
  getTravelTimesByPostcode,
  getTeamAvailability,
  getPostcodeDistance,
} from '../../../actions/areas/dailyPlanning';
import {
  deleteAssignment,
  createAssignment,
  removeTreatmentInstance,
  removeCopyTreatmentInstance,
} from '../../../actions/entities';
import { getPostingsUpdateDataAfterAssign } from '../../../actions/entities/postings';
import { getTreatmentInstancesCopies } from '../../../actions/entities/treatmentInstances';
import TreatmentInstance from '../../../components/DailyPlanning/TreatmentInstance/TreatmentInstance';

const mapStateToProps = ({ global: { auth }, areas: { dailyPlanning } }) => ({
  jwtToken: auth.jwtToken,
  teamId: dailyPlanning.filters.selectedTeam,
  selectedDate: dailyPlanning.selectedDate,
});

const mapDispatchToProps = dispatch => ({
  assignTreatment: assignment => dispatch(createAssignment(assignment)),
  removeAssignment: (assignGuid, postingId) => dispatch(deleteAssignment(assignGuid, postingId)),
  refreshScheduler: async (assignGuid, newAssignmentId, postingId, date, jwtToken, masterTreatmentInstanceId) => {
    await dispatch(
      getPostingsUpdateDataAfterAssign(
        newAssignmentId,
        assignGuid,
        postingId,
        date,
        jwtToken,
        masterTreatmentInstanceId,
      ),
    );
  },
  removeTreatmentInstance: (treatmentId, assignGuid, occurrence, effectiveTimeSlots) =>
    dispatch(removeTreatmentInstance(treatmentId, assignGuid, occurrence, effectiveTimeSlots)),
  removeCopyTreatmentInstance: assignGuid => dispatch(removeCopyTreatmentInstance(assignGuid)),

  getTreatmentInstancesCopies: async (newAssignmentId, teamId, jwtToken) =>
    await dispatch(getTreatmentInstancesCopies(newAssignmentId, teamId, jwtToken)),

  getTeamAvailability: async (teamId, date, jwtToken, timeleft) =>
    await dispatch(getTeamAvailability(teamId, date, jwtToken, timeleft)),
  getTravelTimesByPostcode: postcode => dispatch(getTravelTimesByPostcode(postcode)),
  getPostcodeDistance: postcode => dispatch(getPostcodeDistance(postcode)),
});

const TreatmentInstanceContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TreatmentInstance);

export default TreatmentInstanceContainer;
